import { Ng2StateDeclaration, Transition, UIRouter } from "@uirouter/angular";
import { StorageService } from "../../commons/services/storageService.service";
import { IUserProfile } from "../../types/user";

export const inventoryFutureState: Ng2StateDeclaration = {
    name: "inventory.**",
    url: "/inventory",
    loadChildren: () => import("./inventory.module")
        .then(module => module.InventoryModule)
}

export function inventoryStateConfigFn(uirouter: UIRouter) {
    uirouter.transitionService.onStart(
        { to: "inventory" },
        (transition: Transition) => {
            const storage: StorageService = transition.injector().get(StorageService);
            const currentUser: IUserProfile = storage.get.profile();
            if (!currentUser?.platformUser) {
                transition.abort();
                const fromState = transition.from();
                transition.router.stateService.go(fromState.name ? fromState : 'airtrfx');
            }
        }
    )
}
